<template>
  <project-template
    title="配置随访周期"
    nextBtnText="下一步：样本量计算"
    @lastClick="lastClick"
    @nextClick="nextClick">
    <template v-slot:leftContent>
      <div
      v-for="(item,index) in periodItemList"
      :class="['period-item-card',cur === index && 'cur']"
        :key="item.id"
        @click="viewPeriodItem(item,index)">
        
        <arrive-visit v-if="item.visitType === '1'"></arrive-visit>
        <phone-visit v-else></phone-visit>
        <strong>{{ item.name }}</strong>
        <a-tag color="green" v-if="item.base != '1'">
          距基点{{ item.basePointDay }}天
        </a-tag>
        <a-icon type="right" class="card-img-right"></a-icon>
      </div>
      <div class="period-item-card-add" @click="addPeriodItem">
        <a-icon type="plus"></a-icon>
        <span style="margin-left: 5px;">新增节点</span>
      </div>
    </template>
    <template v-slot:rightContent v-if="editType == 'edit' || (editType == 'view' && current.id)">
      <div class="con-period-item-header">
        <div class="head">
          <icon-base-line></icon-base-line>
          <strong>{{ current.name }}</strong>
          <a-tag color="green" v-if="current.base != '1'">
            距基点{{ (current.basePointDay == null || current.basePointDay === undefined) ? '-' : current.basePointDay
            }}天
          </a-tag>
        </div>
        <div class="all-label">
          <label class="label">
            时间成本：
          </label>
          <label>
            -分钟
          </label>
          <label class="label" style="margin-left: 20px">
            投入成本：
          </label>
          <label>
            -元
          </label>
        </div>
        <div style="margin-top: 10px" class="one-row">
          <div v-if="currentModuleList.length" class="tag-list">
            <a-tag v-for="module in currentModuleList" :key="module.code">
              <a-icon type="question-circle"></a-icon>
              {{ module.name }}
            </a-tag>
          </div>
          <div v-else style="color:rgba(255, 255, 255, 0.4);">
            请选择模块表单
          </div>
        </div>
      </div>
      <div>
        <a-collapse v-model="activeKey" @change="changeActivekey" class="project-collapse">
          <a-collapse-panel key="1" header="节点详情">
            <a-dropdown :trigger="['click']" slot="extra" v-if="editType == 'view'">
            <a @click.stop="e => e.preventDefault()" style="font-size: 14px;color: white;">
              操作 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-button type="link" @click.stop="editPeriodItem()">编辑节点</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button type="link" @click.stop="deletePeriodItem()">删除节点</a-button>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <template v-else slot="extra">
            <a-button
              type="link"
              :loading="loading"
              style="color: white"
              @click.stop="editSubmit">
              完成
            </a-button>
            <a-button
              type="link"
              :loading="loading"
              v-if="current.id"
              style="color: white;"
              @click.stop="editCancel">
              取消
            </a-button>
          </template>

            <div class="con-period-edit-panel">
              <div class="con-period-edit-item">
                <div class="label label2">
                  周期名称
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ current.name || '-' }}
                </div>
                <div v-else>
                  <a-input v-model="currentModel.name"></a-input>
                </div>
              </div>
              <div class="con-period-edit-item">
                <div class="label label2">
                  距离基点天数
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.basePointDay == null || current.basePointDay === undefined) ? '-' : current.basePointDay }}
                </div>
                <div v-else>
                  <a-input-number v-model="currentModel.basePointDay" :min="0" :precision="0" style="width: 100%" />
                </div>
              </div>
            </div>
            <div class="con-period-edit-panel">
              <div class="con-period-edit-item">
                <div class="label label2">
                  最大可提前天数
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.advanceDay == null || current.advanceDay === undefined) ? '-' : current.advanceDay }}
                </div>
                <div v-else>
                  <a-input-number v-model="currentModel.advanceDay" :min="0" :precision="0" style="width: 100%" />
                </div>
              </div>
              <div class="con-period-edit-item">
                <div class="label label2">
                  最大可延后天数
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.delayDay == null || current.delayDay === undefined) ? '-' : current.delayDay }}
                </div>
                <div v-else>
                  <a-input-number v-model="currentModel.delayDay" :min="0" :precision="0" style="width: 100%" />
                </div>
              </div>
            </div>
            <div class="con-period-edit-panel">
              <div class="con-period-edit-item">
                <div class="label label2">
                  允许过期作答
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.answerOverdue == '1') ? '是' : '否' }}
                </div>
                <div v-else>
                  <a-radio-group v-model="currentModel.answerOverdue" button-style="solid">
                    <a-radio-button value="1">
                      是
                    </a-radio-button>
                    <a-radio-button value="0">
                      否
                    </a-radio-button>
                  </a-radio-group>
                </div>
              </div>

              <div class="con-period-edit-item">
                <div class="label label2">
                  允许未到期作答
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.answerUnexpired == '1') ? '是' : '否' }}
                </div>
                <div v-else>
                  <a-radio-group v-model="currentModel.answerUnexpired" button-style="solid">
                    <a-radio-button value="1">
                      是
                    </a-radio-button>
                    <a-radio-button value="0">
                      否
                    </a-radio-button>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="con-period-edit-panel">
              <div class="con-period-edit-item">
                <div class="label label2">
                  随访类型
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.visitType == null || current.delayDay === undefined) ? '-' : (current.visitType === '0'?'电话随访':'到院随访') }}
                </div>
                <div v-else>
                  <a-select v-model="currentModel.visitType" style="width: 100%">
                    <a-select-option value="0">
                      电话随访
                    </a-select-option>
                    <a-select-option value="1">
                      到院随访
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <div class="con-period-edit-item">
                <div class="label label2">
                  排序
                </div>
                <div v-if="editType == 'view'" class="label-value">
                  {{ (current.sortNum == null || current.sortNum === undefined) ? '-' : current.sortNum }}
                </div>
                <div v-else>
                  <a-input-number v-model="currentModel.sortNum" :min="0" :precision="0" style="width: 100%" />
                </div>
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>


        <div class="con-period-edit-panel" style="margin-top: 20px;">
          <div class="con-period-edit-item" v-if="editType == 'edit' && currentModel.base != '1'">
            <div class="label">
              <a-button type="primary" @click="copylast">复制上一个节点内容</a-button>
            </div>
          </div>
        </div>
        <div class="con-period-edit-panel" style="margin-top: 5px;">
          <div class="con-period-edit-item">
            <!--<div class="label3">
              <strong>量表选择</strong>
              <a-radio-group v-model="currentModel.diseaseCode" @change="diseaseChange" button-style="solid">
                <a-radio-button :value="disease.code" :key="disease.code" v-for="disease in diseaseModuleList">
                   {{ disease.name }}
                    <a-tag color="blue" v-if="disease.main">
                      主病种
                    </a-tag>
                    <a-tag  v-else>
                      次病种
                    </a-tag>  
                  <span v-if="disease.main">主病种</span>
                  <span v-else>次病种</span>
                </a-radio-button>
              </a-radio-group>
            </div>-->
            <div class="module-item-panel">
              <!-- <strong style="display: block; color: white;margin-bottom: 10px;">模块：</strong> -->
              <a-radio-group v-model="currentModel.moduleId" button-style="solid">
                <a-radio-button :value="module.id" :key="module.id" v-for="module in moduleList">
                  <!--<a-icon type="question-circle"></a-icon>-->
                  {{ module.name }}
                </a-radio-button>
              </a-radio-group>
            </div>
            <a-checkbox-group v-model="currentModel.formIdList" style="width: 100%;">
              <a-row :gutter="20" type="flex" style="row-gap: 20px;">
                <template v-for="(form, index) in diseaseModuleFormList">
                  <a-col :span="12" :key="index" v-show="form.moduleId == currentModel.moduleId || form.moduleId.indexOf(currentModel.moduleId)>-1">
                    <form-card :form-info="form" :disabled="editType == 'view'"></form-card>
                  </a-col>
                </template>
              </a-row>
            </a-checkbox-group>
          </div>
        </div>
      </div>
    </template>
  </project-template>
</template>

<script>
import IconBaseLine from '@comp/Icon/IconBaseLine'
import PeriodItemCard from './projectTemplate2/comp/PeriodItemCard'
import Module from './projectTemplate2/Module'
import Disease from '@views/apppad/projectTemplate/projectTemplate2/Disease'
import Dept from '@views/apppad/projectTemplate/projectTemplate2/Dept'
import { deleteAction, getAction, postAction } from '@api/manage'
import FormCard from '@views/apppad/projectTemplate/comp/FormCard'
import PhoneVisit from '@comp/Icon/PhoneVisit'
import ArriveVisit from '@comp/Icon/ArriveVisit'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
export default {
  name: 'StepFive',
  components: { FormCard, Dept, Disease, Module, PeriodItemCard, IconBaseLine, ProjectTemplate, PhoneVisit, ArriveVisit },
  data() {
    return {
      project: {},
      periodItemList: [],
      editType: 'view',
      cur: 0,
      current: {},
      currentModel: {
        formIdList: []
      },
      loading: false,
      activeKey: [],
    }
  },
  watch: {
    data() {
    }
  },
  computed: {
    currentModuleList() {
      let result = []
      if (this.current.moduleFormJson) {
        result = JSON.parse(this.current.moduleFormJson)
      }
      return result
    },
    moduleList() {
      return this.moduleListHandle(this.currentModel.diseaseCode)
    },
    moduleListAll() {
      let result = []
      if (this.project.moduleJson) {
        // {病种code:[{name:'模块名',code:'模块code',checkedFormList:[name:'表单名称',code:'表单code']}]}
        const moduleObject = JSON.parse(this.project.moduleJson)
        for (let key in moduleObject) {
          result = result.concat(moduleObject[key])
        }
      }
      return result
    },
    diseaseModuleList() {
      let result = []
      if (this.project.diseaseJson) {
        // [{code:'',name:'病种'}]
        result = JSON.parse(this.project.diseaseJson)
      }
      return result
    },
    diseaseModuleFormList() {
      let result = []
      this.moduleListAll.forEach(module => {
        if(this.currentModel.moduleId===module.id){
          // console.log("moduleforms:"+module.id + ",len:" + module.checkedFormList.length)
          result = result.concat(module.checkedFormList || [])
        }
      })
      return result
    }
  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    changeActivekey(a){
      console.log('a',JSON.parse(JSON.stringify(a)))
    },
    copylast() {
      // 复制上一个节点内容
      this.$confirm({
        title: '提示',
        content: '确认要复制上一个节点的量表内容吗?复制过后将覆盖已选内容。',
        onOk: () => {
          let thisIndex = -1
          if (this.current.id) {
            this.periodItemList.forEach((item, index) => {
              if (item.id == this.current.id) {
                thisIndex = index
              }
            })
          } else if (this.periodItemList.length > 0) {
            thisIndex = this.periodItemList.length
          }
          const lastPeriod = this.periodItemList[thisIndex - 1]
          this.$set(this.currentModel, 'formIdList', this.createCurrentModuleFormCodeList(lastPeriod))
        },
        onCancel: () => {
        }
      })
    },
    diseaseChange() {
      this.$nextTick(() => {
        this.handleModuleCodeDefault()
      })
    },
    moduleListHandle(diseaseCode) {
      let result = []
      if (this.project.moduleJson) {
        // {病种code:[{name:'模块名',code:'模块code',checkedFormList:[name:'表单名称',code:'表单code']}]}
        const moduleObject = JSON.parse(this.project.moduleJson)
        result = moduleObject[diseaseCode] || []
      }
      return result
    },
    editSubmit() {
      if (!this.currentModel.name) {
        return this.$message.warn('请输入周期名称')
      }
      if (this.currentModel.basePointDay == null) {
        return this.$message.warn('请输入距离基点天数')
      }
      if (this.currentModel.advanceDay == null) {
        return this.$message.warn('请输入最大可提前天数')
      }
      if (this.currentModel.delayDay == null) {
        return this.$message.warn('请输入最大可延后天数')
      }
      if (!this.currentModel.answerUnexpired) {
        return this.$message.warn('请选择允许未到期作答')
      }
      if (!this.currentModel.answerOverdue) {
        return this.$message.warn('请选择允许过期作答')
      }
      if (this.currentModel.sortNum == null) {
        return this.$message.warn('请输入排序')
      }
      if (!this.currentModel.formIdList.length) {
        return this.$message.warn('请选择至少一个表单')
      }
      // 处理表单选项内容
      // const moduleFormObj = {}
      // this.moduleListAll.forEach(module => {
      //   (module.checkedFormList||[]).forEach(form => {
      //     if (this.currentModel.formIdList.indexOf(form.id) >= 0) {
      //       moduleFormObj[module.code] = moduleFormObj[module.code] || []
      //       moduleFormObj[module.code].push(form)
      //     }
      //   })
      // })
      // const moduleFormList = []
      // this.moduleListAll.forEach(module => {
      //   if (moduleFormObj[module.code] && moduleFormObj[module.code].length > 0) {
      //     const newmodule = JSON.parse(JSON.stringify(module))
      //     delete newmodule.checkedFormList
      //     newmodule.formList = moduleFormObj[module.code]
      //     moduleFormList.push(newmodule)
      //   }
      // })
      this.currentModel.sourceFormIdList = this.currentModel.formIdList
      const params = JSON.parse(JSON.stringify(this.currentModel))
      // params.moduleFormJson = JSON.stringify(moduleFormList)
      this.loading = true
      postAction('/projectconfigview/periodItem/save2', params).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.current = res.result
          this.editType = 'view'
          this.loadData(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    editCancel() {
      this.$confirm({
        title: '确认取消吗',
        content: (<div>
          <p>您确定要取消编辑吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          this.editType = 'view'
        }
      })
    },
    viewPeriodItem(item,index) {
      this.cur = index;
      if (this.current.id == item.id) {
        return
      }
      this.current = item
      this.editType = 'view'
      this.createEditModel()
    },
    addPeriodItem() {
      this.editType = 'edit';
      this.activeKey = ['1'];
      const base = this.periodItemList.length == 0 ? '1' : '0'
      const sortNum = this.periodItemList.length
      this.current = {
        formIdList: [],
        basePointDay: 0,
        advanceDay: 0,
        delayDay: 0,
        answerUnexpired: '0',
        answerOverdue: '0',
        base: base,
        sortNum: sortNum,
        name: this.periodItemList.length == 0 ? '基线' : '',
        projectId: this.project.projectId
      }
      this.createEditModel()
    },
    editPeriodItem() {
      this.editType = 'edit'
      this.activeKey = ['1'];
      this.createEditModel()
    },
    createCurrentModuleFormCodeList(currentModel) {
      const formIdList = []
      if (currentModel.sourceFormIdList) {
        currentModel.sourceFormIdList.forEach(formId => {
          formIdList.push(formId)
        })
      }
      return formIdList
    },
    createEditModel() {
      this.$nextTick(() => {
        const currentModel = JSON.parse(JSON.stringify(this.current))
        currentModel.formIdList = this.createCurrentModuleFormCodeList(currentModel)
        this.currentModel = currentModel
        this.$nextTick(() => {
          this.handleDiseaseCodeDefault()
          this.handleModuleCodeDefault()
        })
      })
    },
    handleDiseaseCodeDefault() {
      if (this.diseaseModuleList.length) {
        this.$set(this.currentModel, 'diseaseCode', this.diseaseModuleList[0].code)
      }
    },
    handleModuleCodeDefault() {
      const moduleList = this.moduleListHandle(this.currentModel.diseaseCode)
      if (moduleList.length > 0) {
        this.$set(this.currentModel, 'moduleId', moduleList[0].id)
      } else {
        this.$set(this.currentModel, 'moduleId', '')
      }
    },
    deletePeriodItem() {
      this.$confirm({
        title: '删除周期',
        content: (<div>
          <p>您确定要彻底删除这个周期吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          this.loading = true
          deleteAction('/projectconfigview/periodItem/delete2', { id: this.current.id }).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.current = {}
              this.currentModule = {}
              this.loadData(true)
            } else {
              this.$message.warning(res.message)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadData(isquery) {
      let url = '/projectconfigview/periodItem/listAll2' //会根据当前方案自动重新生成周期
      if(isquery){
        url = '/projectconfigview/periodItem/listAll' //仅仅查询已经生成的周期
      }
      const id = this.$route.query.id
      getAction(url, { projectId: id }).then(res => {
        if (res.success) {
          this.periodItemList = res.result
          if (!this.current.id) {
            if (this.periodItemList.length == 0) {
              this.addPeriodItem()
            } else {
              this.viewPeriodItem(this.periodItemList[0],0)
            }
          }
        }
      })
    },
    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryById', { id: id }).then(res => {
        if (res.success) {
          this.project = res.result
          this.loadData()
        }
      })
    },
    nextClick() {
      this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    }
  }
}
</script>

<style scoped lang="less">
.project-template {
  .project-collapse{
      border-color: #575757;
      background: transparent;
    /deep/ .ant-collapse-header{
      color: white;
      background: #373e5d;
    }
    /deep/ .ant-collapse-content{
      background: #1d2132;
      border-top:1px solid #575757;

      .con-period-edit-panel {
        margin-bottom: 20px;
      }

      .con-period-edit-panel:last-child {
        margin-bottom: 0;
      }
    }

    /deep/ .ant-collapse-item{
      border-bottom:1px solid #575757;
    }

    /deep/ .ant-collapse-extra{
      margin-top: -4px;
    }
  }
  .con-period-edit-panel {
    // height: calc(100vh - 210px);
    // overflow-y: auto;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    // margin-bottom: 20px;
  }



  .con-period-item-header {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 20px;

    // width: 867px;
    // height: 134px;
    background: #373e5d;

    .head {
      display: flex;
      align-items: center;

      strong {
        font-size: 18px;
        color: white;
        margin: 0 10px;
      }
    }

    .all-label {
      padding: 5px 0;

      .label,
      label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);
      }
    }

    .tag-list {
      .ant-tag {
        padding: 2px 7px;
        color: rgba(255, 255, 255, 0.7);
        border: 0;
        background: rgba(255, 255, 255, 0.15);
      }
    }
  }

  .con-period-edit-header {
    label {
      font-size: 16px;
      color: white;
    }

    margin-bottom: 5px;
    font-size: 18px;
  }

  .period-item-card {
    display: flex;
    align-items: center;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 12px;
    padding: 16px 10px;
    margin-bottom: 20px;
    background-size: cover;
    background-image: url(~@/assets/item_bg.png);

    .card-img {
      margin-right: 10px;
    }

    .card-img-right {
      margin-left: auto;
      margin-top: 3px;
    }

    strong {
      font-size: 18px;
      font-weight: normal;
      margin: 0 10px;
    }
  }

  .cur{
    background-color: #376eff;
    background-image :none;
  }

  .period-item-card-add {
    border: 1px dashed rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.07);
    padding: 13px 0;
    margin-bottom: 20px;
    text-align: center;
    color: white;

    span {
      font-size: 16px;
    }
  }

  .module-item-panel {
    // width: calc(100% - 20px);
    overflow-x: auto;
    // white-space: nowrap;
    padding: 10px 0;

    .module-item {
      display: inline-table;
    }
  }

  .con-period-edit-item {
    flex: 1;
    padding: 10px 15px;

    .label2 {
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 16px;
      margin-bottom: 10px;
    }

    .label-value {
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 20px;
    }

    .label3 {
      display: flex;
      align-items: center;
      justify-content: space-between;

      strong {
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }

  // .ant-radio-button-wrapper {
  //   color: #376EFF;
  //   background: #C3D4FF;
  //   border-color: #C3D4FF;
  // }
  // .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  //   color: white;
  //   background: #376EFF;
  //   border-color: #376EFF;
  // }

  
}
</style>
